import { render, staticRenderFns } from "./industryPolicy.vue?vue&type=template&id=22b5a658&scoped=true"
import script from "./industryPolicy.vue?vue&type=script&lang=js"
export * from "./industryPolicy.vue?vue&type=script&lang=js"
import style0 from "./industryPolicy.vue?vue&type=style&index=0&id=22b5a658&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5a658",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b5a658')) {
      api.createRecord('22b5a658', component.options)
    } else {
      api.reload('22b5a658', component.options)
    }
    module.hot.accept("./industryPolicy.vue?vue&type=template&id=22b5a658&scoped=true", function () {
      api.rerender('22b5a658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/industryChainNew/page/industryPolicy.vue"
export default component.exports